import React, { FC } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import device from '../mediaQueries';
import { useUrlBuilder } from '../../hooks/useUrlBuilder';

const LogoImgStyled = styled.img`
  ${({ width }) => `width: ${width || '61px'};`}
  ${({ height }) => `height: ${height || '25px'};`}
  ${device.desktop`
    ${({ width }) => `width: ${width || '101px'};`}
    ${({ height }) => `height: ${height || '40px'};`}
 `}
  ${({ margin }) => (margin ? `margin: ${margin};` : null)}
`;

export const LogoImg = ({ margin, width, height }) => {
  const { withCDN } = useUrlBuilder();
  return (
    <LogoImgStyled
      alt="Luxury Italian Fashion Boutique: clothes, shoes, bags | italist"
      src={withCDN('mkt/logo_small.png')}
      margin={margin}
      width={width}
      height={height}
    />
  );
};

const Logo = props => {
  const { localized } = useUrlBuilder();
  return (
    <>
      <h1 className="logo">
        <a
          id="logo-img"
          href={localized()}
          title="italist - Luxury Italian Fashion Boutique: clothes, shoes, bags | italist"
        >
          <LogoImg />
        </a>
      </h1>

      <style jsx>{`
        .logo {
          width: auto;
          margin-top: -10px;
        }

        @media (min-width: 1024px) {
          .logo {
            margin-top: 5px;
          }
        }
      `}</style>
    </>
  );
};

export default Logo;
